import { computed, defineComponent, h } from 'vue'

import { injectHighlightTerms } from '@/composables/useHighlightTerms'
import { highlightParts } from '@/helpers/highlightText'

export default defineComponent({
  name: 'HighlightedText',
  props: { text: { type: String, default: '' } },
  setup(props) {
    const terms = injectHighlightTerms()
    const parts = computed(() => highlightParts(props.text, terms.value))
    return () =>
      h(
        'span',
        parts.value.map(part =>
          part.strong ? h('strong', { class: 'font-semibold text-gray-900' }, part.text) : part.text
        )
      )
  }
})
